import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { catchError } from 'rxjs';
import { userSession } from 'src/app/core/constants/names-local.constants';
import { ProcedureFilterDto } from 'src/app/core/models/configuration/procedures/procedure-filters.dto';
import { ProcedureDto } from 'src/app/core/models/configuration/procedures/procedure.dto';
import { GenericResponse } from 'src/app/core/models/generic/generic.response';
import { CatProcedureService } from 'src/app/core/services/configuration/catalog-procedure.service';

@Component({
  selector: 'app-procedures-master-autocomplete',
  templateUrl: './procedures-master.autocomplete.component.html',
  styleUrls: ['./procedures-master.autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProceduresMasterAutocompleteComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ProceduresMasterAutocompleteComponent),
      multi: true
    }
  ]
})
export class ProceduresMasterAutocompleteComponent implements OnInit, ControlValueAccessor, Validator {

  @Input() label: string | null = null;
  @Input() placeholder: string = '';
  @Input() errorStr: string = '';
  @Input() maskSelection: string | null = null;
  @Input() patientId: number | null;
  @Input() required: boolean = false;
  @Input() showRequiredIndicator: boolean = false;
  @Input() minLengthSearch?: number = 0;
  @Input() markControlAsTouched: boolean = false;

  @Output() isLoadingChange = new EventEmitter<boolean>();
  @Output() onChangeSelected = new EventEmitter<ProcedureDto>();

  // AUTOCOMPLETE  DIAGNOSTICO MAESTRO
  public resultItemsList: ProcedureDto[] = [];
  public isLoading = false;
  private _filters: ProcedureFilterDto = {
    branchOfficeId: Number(localStorage.getItem(userSession.idbranch)),
    status: 2,
    patientId: null,
  };
  public myFormControl = new FormControl();

  /**
   *
   * @param diagMasterService
   */
  constructor(private catProcedureService: CatProcedureService) { }

  @Input() set filters(filtersReq: ProcedureFilterDto) {
    if (!!filtersReq) {
      this._filters = filtersReq;
    }
  }

  ngOnInit(): void {
    if (this.required) {
      this.myFormControl.setValidators(Validators.required);
      this.myFormControl.reset();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['patientId'] && this.patientId) {
      this._filters.patientId = this.patientId;
      this.onChangefilterDiagnosticMaster();
    }
    if (changes['markControlAsTouched']) {
      this.markAsSubmitted();
    }
  }

  // Event (blur)
  clearDiagnosticNameIfNotSelected() {
    const currentValue = this.myFormControl.value;
    const isOptionSelected = this.resultItemsList
      .some(option => this.applyMaskSelection(option) === currentValue);
    if (!isOptionSelected) {
      this.myFormControl.setValue(null);
      this.onChangeSelected.emit(null);
    }
  }
  
  // Event (input)
  onChangefilterDiagnosticMaster() {
    this.isLoadingChange.emit(true);
    this.isLoading = true;
    let procStr: string = this.myFormControl.value;
    if (procStr && procStr.length >= this.minLengthSearch) {
      this._filters.procedimiento = procStr;
  
      this.catProcedureService.getProceduresByFilters(this._filters, true)
        .pipe(catchError((error) => {
          console.error(error);
          return error;
        }))
        .subscribe((element: GenericResponse) => {
          this.resultItemsList = element.response.listProcedures.filter(proc => proc.catalogKey.length == 4);
        })
        .add(() => {
          this.isLoading = false;
          this.isLoadingChange.emit(false);
        });
    }
  }


  onDiagnosticItemSelected(event: MatAutocompleteSelectedEvent) {
    var option: ProcedureDto = event.option.value;
    this.myFormControl.setValue(this.applyMaskSelection(option));
    this.onChangeSelected.emit(option);
  }


  applyMaskSelection(itemSelected: ProcedureDto): string {
    if (!this.maskSelection || !itemSelected) return '';

    const variables: string[] = this.maskSelection.match(/\${.*?}/g) || [];
    let result = this.maskSelection;

    variables.forEach(variable => {
      const key = variable.slice(2, -1);
      const value = itemSelected[key] ?? '';
      result = result.split(variable).join(value);
    });
    return result;
  }

  markAsSubmitted(): void {
    this.myFormControl.markAsTouched({ onlySelf: true });
  }

  // Implementación de ControlValueAccessor
  writeValue(value: any): void {
    this.myFormControl.setValue(value);
  }

  registerOnChange(fn: any): void {
    this.myFormControl.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.myFormControl.valueChanges.subscribe(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.myFormControl.disable();
    } else {
      this.myFormControl.enable();
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.myFormControl.errors;
  }
}
